import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionManager } from '@zelis/platform-ui-components';

@Component({
  selector: 'app-search-by-billing-link',
  templateUrl: './search-by-billing-link.component.html',
})
export class SearchByBillingLinkComponent implements OnDestroy {
  private subscriptions = new SubscriptionManager();

  constructor(private router: Router) {}

  public ngOnDestroy() {
    this.subscriptions.destroy();
  }

  public handleClick(): void {
    this.router.navigate(['billing-code-search'], {
      queryParamsHandling: 'merge',
    });
  }
}
